import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback, useEffect, useRef } from "react";
const useStyles = makeStyles((theme) => ({
    wrapper: {
        height: (props) => props.height || 64,
        width: (props) => props.width || 64,
        minHeight: (props) => props.height || 16,
        minWidth: (props) => props.width || 16
    },
    background: {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "100%",
        height: "100%",
        transition: "transform 600ms ease-in-out",
        borderRadius: (props) => (props.borderRadius ? 6 : 0),
        "&.imageLoader": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:after": {
                content: "' '",
                display: "block",
                width: 44,
                height: 44,
                margin: 6,
                borderRadius: "50%",
                border: `4px solid ${theme.palette.primary.main}`,
                borderColor: `${theme.palette.primary.main} transparent ${theme.palette.primary.main} transparent`,
                animation: "$imageLoader 1.2s linear infinite"
            }
        },
        "&.imageFadeIn": {
            animation: "$fadeIn 400ms linear"
        }
    },
    "@keyframes fadeIn": {
        "100%": {
            opacity: 1
        },
        "0%": {
            opacity: 0
        }
    },
    "@keyframes imageLoader": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    }
}));
export const Picture = (props) => {
    const classes = useStyles(props);
    const { imageUrl, className, altText } = props;
    const backgroundRef = useRef();
    const image = new Image();
    const loadImage = useCallback((ref) => {
        if (ref.current) {
            ref.current.classList.remove("imageLoader");
            ref.current.style.backgroundImage = `linear-gradient(232deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.48) 100%), url(${image.src})`;
            ref.current.classList.add("imageFadeIn");
        }
    }, []);
    useEffect(() => {
        image.src = imageUrl;
        const fallbackTimeout = setTimeout(() => {
            image.onload = null;
            loadImage(backgroundRef);
        }, 5000);
        image.onload = () => {
            if (backgroundRef.current) {
                clearTimeout(fallbackTimeout);
                loadImage(backgroundRef);
            }
        };
        return () => {
            clearTimeout(fallbackTimeout);
        };
    }, [image, imageUrl, backgroundRef]);
    return (React.createElement("div", { className: `${classes.wrapper} ${className}` },
        React.createElement("div", { role: "img", "aria-label": altText, className: `${classes.background} imageLoader`, ref: backgroundRef })));
};
export default Picture;
//# sourceMappingURL=Picture.js.map